import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import { Textarea, Typography, useColorMode } from '@airbus/components-react/components'
import TextInput, { TextInputProps } from '@airbus/components-react/components/TextInput'
import FormControl from './FormControl'
import { FormControlProps } from '@airbus/components-react/components/Form'

type CustomInputProps = TextInputProps & FormControlProps & { onChange?: (v: string) => void }

export const CustomInput = ({
  label,
  error,
  readOnly = false,
  value,
  emptyValue,
  onChange,
  capitalize,
  style,
  labelAdornment,
  multiline = false,
  required = false,
  ...rest
}: CustomInputProps) => {
  const theme = useColorMode()
  return (
    <FormControl
      label={label}
      error={error}
      readOnly={readOnly}
      labelAdornment={labelAdornment}
      required={required}
      style={style}
    >
      {readOnly ? (
        multiline && value ? (
          <Textarea style={{ opacity: 1, fontWeight: 'bold' }} readOnly>
            {value || (emptyValue ?? '-')}
          </Textarea>
        ) : (
          <Typography
            style={{
              textTransform: capitalize ? 'uppercase' : 'initial',
              fontWeight: 'bold',
              lineHeight: theme.size.spacing[40],
              overflowX: 'auto',
            }}
          >
            {value || (emptyValue ?? '-')}
          </Typography>
        )
      ) : (
        <TextInput
          value={value || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange && onChange(capitalize ? e.target.value.toUpperCase() : e.target.value)
          }
          multiline={multiline}
          style={{
            textTransform: capitalize ? 'uppercase' : 'initial',
            resize: multiline ? 'both' : 'initial',
          }}
          tabIndex={0}
          {...rest}
        />
      )}
    </FormControl>
  )
}

export const FormInput = (props: FormFieldProps<CustomInputProps>) => <FormField {...props} Component={CustomInput} />

export default FormInput
